<template>
  <div
    v-click-outside="close"
    :class="['x-single-date-picker-wrapper', { 'disabled': disabled, 'label-outside': isLabelOutside }]"
  >
    <div
      v-if="isLabelOutside"
      class="label-outside"
    >
      {{ label }}
    </div>
    <div
      :class="[{ 'remove-border-input': toggle, 'disabled': disabled, 'is-invalid': isInvalid }, 'date-input']"
      @click="toggleCalendar"
    >
      <ic-calendar
        v-if="!hideIcon"
        class="date-picker-ic-calendar"
      />
      <span
        v-if="!value && label && !isLabelOutside"
        class="picker-inner-label"
      >{{ label }}</span>
      <!-- eslint-disable -->
      <input
        v-model="value"
        size="1"
        :class="{ 'disabled': disabled }"
        readonly
      >

      <span
        v-if="!hideIcon"
        :class="['date-picker-ic-dropdown', { 'dropdown-open': toggle, 'hide-dropdown': disabled }]"
      >
        <ic-dropdown />
      </span>
    </div>

    <div
      v-if="toggle"
      :class="[
        {'remove-border-date-picker': toggle},
        'x-date-picker',
        'x-single-date-picker'
      ]"
    >
      <flat-pickr
        ref="datePickerWrap"
        v-model="value"
        :config="config"
        @on-change="changed"
      />
    </div>
    <!-- eslint-enable -->
  </div>
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import { French } from 'flatpickr/dist/l10n/fr.js'
  import icCalendar from '@/svg/ic-calendar'
  import icDropdown from '@/svg/ic-dropdown'
  import vClickOutside from 'v-click-outside'

  export default {
    name: 'XDatePicker',

    components: {
      flatPickr,
      icCalendar,
      icDropdown
    },

    directives: {
      clickOutside: vClickOutside.directive
    },

    props: {
      minDate: {
        type: [String, Date],
        default: null
      },
      maxDate: {
        type: [String, Date],
        default: null
      },
      value: {
        type: String,
        default: null
      },
      isInvalid: {
        type: Boolean,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      hideIcon: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      disableDates: {
        type: Array,
        default: () => []
      },
      isLabelOutside: Boolean
    },

    data () {
      return {
        toggle: false
      }
    },

    directives: {
      clickOutside: vClickOutside.directive
    },

    computed: {
      config () {
        return {
          locale: French,
          inline: true,
          shorthandCurrentMonth: true,
          monthSelectorType: 'static',
          defaultDate: this.defaultDate,
          minDate: this.minDate,
          maxDate: this.maxDate,
          dateFormat: 'd-m-Y',
          disable: this.disableDates
        }
      }
    },

    watch: {
      defaultDate (nVal) {
        this.$refs.datePickerWrap.fp.setDate(nVal)
      }
    },

    methods: {
      toggleCalendar () {
        if (!this.disabled) {
          this.toggle = !this.toggle
        }
      },

      changed (newDates, dateStr, instance) {
        this.toggle = false
        this.$emit('input', dateStr)
      },

      close () {
        this.toggle = false
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import '~@/styles/datepicker.scss';

  .x-single-date-picker-wrapper {
    position: relative;

    &.label-outside {
      .date-input {
        margin-top: 1.8rem;
      }
    }

    .label-outside {
      line-height: 1.8rem;
      bottom: 48px;
      font-size: 1.2rem;
      font-weight: 600;
      color: $color-silver !important;
      padding: 0 1.4rem 0.4rem 1.4rem;
      position: absolute;
      text-transform: uppercase;
    }

    &.disabled {
      background-color: $color-whisper;

      .label-outside {
        background: white;
      }
    }

    .date-input {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 2rem;
      border: 2px solid #E5EAF5;
      box-sizing: border-box;
      border-radius: 4px;

      &.remove-border-input {
        border-radius: 4px 4px 0 0;
        border-bottom: none;
      }

      input {
        margin: 0 0.5rem;
        flex: 1;
        border: none;
        font-size: 1.6rem;
        font-weight: 600;
        font-family: "Source Sans Pro";

        &:focus {
          outline: none;
        }

        &.disabled {
          background-color: $color-whisper;
        }
      }
      .date-picker-ic-calendar {
        min-width: 1.2rem;
      }

      .date-picker-ic-dropdown {
        min-width: 2rem;
      }

      .dropdown-open {
        transform: rotateX(180deg);
      }

      .hide-dropdown {
        visibility: hidden;
      }

      &.is-invalid {
        border-color: $color-red !important;
      }
    }

    /deep/ .x-date-picker.x-single-date-picker .flatpickr-months .flatpickr-month .flatpickr-current-month .numInputWrapper {
      position: relative;

      .numInput.cur-year {
        -moz-appearance: textfield;

        &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }

      span {
        border: 1px solid rgba(57,57,57,0.15);
        box-sizing: border-box;
        cursor: pointer;
        height: 50%;
        line-height: 50%;
        padding: 0 4px 0 2px;
        position: absolute;
        right: 0;
        -webkit-box-sizing: border-box;
        width: 14px;

        &:after {
          border-bottom-color: rgba(0,0,0,0.9);
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          content: "";
          display: block;
          position: absolute;
        }

        &.arrowDown {
          bottom: 0;

          &:after {
            border-top: 4px solid rgba(57,57,57,0.6);
            top: 40%;
          }
        }

        &.arrowUp {
          top: 0;

          &:after {
            border-bottom: 4px solid rgba(57,57,57,0.6);
            top: 26%;
          }
        }
      }
    }
    .picker-inner-label {
      color: #454545;
      padding-left: 10px;
      font-size: 1.6rem;
      font-family: 'Open Sans Regular', sans-serif;
    }

    /deep/.flatpickr-disabled {
      color: #c9c9c9;
    }
  }
</style>
